// Aquí puedes añadir todas las listas de textos que quieras usar en la app.

export const loginSubtitles = [
  'Un rincón con informacion especial.',
  'El universo que encontré en ti.',
  '¿Que haremos hoy?',
  'Donde cada día contigo es mi día favorito.',
  'Mi cariño por ti a la velocidad de la luz',
  'La mejor parte de mi día, eres tú.',
  'Nuestro pequeño caos perfectamente ordenado.',
  'Bienvenida a tu página de inicio.',
  'Nuestro pequeño caos perfectamente ordenado.',
  'Mi notificación favorita siempre eres tú.',
  'Nuestra conexión no necesita contraseña.',
  'Cargando nuestra siguiente aventura...',
  'Nuestra historia, el código mejor escrito.',
  'Aquí se guardan nuestros mejores momentos.',
  'Nuestro pequeño caos perfectamente ordenado.',
  'El modulo principal de mi vida.',
];

export const dashboardGreetings = [
  '¿Lista para una nueva sorpresa?',
  'Es un día maravilloso, como tú.',
  '¡Qué bueno verte por aquí de nuevo!',
  'Espero que esto te saque una sonrisa.',
];

// --- NUEVA LISTA DE FRASES PARA LA CAJA DE TEXTO ---
export const textboxPlaceholders = [
  "¿Qué tienes en mente, linda?",
  "Escribe una idea para hoy...",
  "Un pensamiento, un recuerdo...",
  "Deja aquí una nota para después.",
  "¿Cuál es el plan, doctora?",
  "Dime que antojo te cumplo.",
  "¿Como va tu día?",
];
